// eslint-disable-next-line jsdoc/require-jsdoc
export function mergeOptions(base, override) {
    return {
        filter: override.filter
            ? { ...base.filter, ...override.filter }
            : base.filter,
        unzip: override.unzip ? { ...base.unzip, ...override.unzip } : base.unzip,
        ungzip: override.ungzip
            ? { ...base.ungzip, ...override.ungzip }
            : base.ungzip,
        logger: override.logger ?? base.logger,
    };
}
//# sourceMappingURL=Options.js.map